import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
const moment = _moment;

import { MY_DATE_FORMATS, FilterStructure, GeneralFilterComponent } from '../../../models/generic-filter';

@Component({
  selector: 'app-rendicontazione-generale-filter',
  templateUrl: './rendicontazione-generale-filter.component.html',
  styleUrls: ['./rendicontazione-generale-filter.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
  ],
})
export class RendicontazioneGeneraleFilterComponent extends GeneralFilterComponent implements OnInit {
    @Input() emissioni: any[];

    @Output() updateFilterEmitter = new EventEmitter();

    emissioniSelectedControl: FormControl;

    constructor(private adapter: DateAdapter<any>) {
        super();
        this.adapter.setLocale('it');
    }

    ngOnInit() {
        super.setResetContext(false);
        this.filterFormGroup = new FormGroup({
            periodoInizioControl: new FormControl({ value: moment(), disabled: false, }),
            periodoFineControl: new FormControl({ value: moment(), disabled: false, }),
            emissioniSelectedControl: new FormControl([]),
        });
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                let val = filterFormGroup[key];
                this.filterFormGroup.get(key).valueChanges.subscribe(() => {
                    if(!super.getResetContext())
                        this.updateFilters();
                });
                console.log("filterFormGroup", key, val);
            }
        }
        this.resetFilters();
    }

    ngOnChanges(changes: any){
		console.log('CHANGE STATISTICHE-GENERALI-FILTER', changes);
		if(changes.filter){
            console.log('CHANGE STATISTICHE-GENERALI FILTER', changes.filter);
            this.updateFilters();
		}
        if(changes.emissioni){
            let localEmissioneSelected = [];
            console.log('CHANGE STATISTICHE-GENERALI EMISSIONI', changes.emissioni);
            if(this.filterFormGroup){
                this.filterFormGroup.get('emissioniSelectedControl').setValue([]);
                localEmissioneSelected = this.filterFormGroup.get('emissioniSelectedControl').value;
            }
            if(!this.emissioni){
                this.emissioni = [];
            }
            this.updateFilters();
            console.log('CHANGE STATISTICHE-GENERALI EMISSIONI', localEmissioneSelected);
		}
	}

    findEmissione(element: any){
        //console.log("emissioniSelected findEmissione", element, this);
        return element.id == this;
    }

    generateFilterMap(){
        let filterStructureLocal: any = null;
        super.resetFilterMap();
        let periodoInizioValue = null;
        let periodoFineValue = null;
        let periodoInizioDate = "";
        let periodoFineDate = "";
        let emissioniSelectedValue = [];

        if(this.filterFormGroup){
            periodoInizioValue = this.filterFormGroup.get('periodoInizioControl').value;
            periodoFineValue = this.filterFormGroup.get('periodoFineControl').value;
            emissioniSelectedValue = this.filterFormGroup.get('emissioniSelectedControl').value;
        }
        if(periodoInizioValue){
            periodoInizioDate = periodoInizioValue.format('YYYY-MM-DD');
        }
        if(periodoFineValue){
            periodoFineDate = periodoFineValue.format('YYYY-MM-DD');
        }
        if(emissioniSelectedValue.length){
            console.log("emissioniSelected", emissioniSelectedValue);
            let emissioneLocal = null;
            let emissioniSelectedLocal = [];
            for(let emissioneSelected of emissioniSelectedValue){
                emissioneLocal = null;
                emissioneLocal = this.emissioni.find(this.findEmissione, emissioneSelected);
                emissioniSelectedLocal.push(emissioneLocal);
            }
            emissioniSelectedValue = emissioniSelectedLocal;
            console.log("emissioniSelected emissioniSelectedValue", emissioniSelectedValue);
        }

        filterStructureLocal = {
            "name": "dataPagamento",
            "object": periodoInizioValue,
            "value": periodoInizioDate,
            "itemKey": "",
            "filterKey": "",
            "type": "date",
            "op": ">=",
        };
        super.setFilterStructure("periodoInizio", filterStructureLocal);

        filterStructureLocal = {
            "name": "dataPagamento",
            "object": periodoFineValue,
            "value": periodoFineDate,
            "itemKey": "",
            "filterKey": "",
            "type": "date",
            "op": "<="
        };
        super.setFilterStructure("periodoFine", filterStructureLocal);

        filterStructureLocal = {
			"name": "emissioniSelected",
			"object": null,
			"value": emissioniSelectedValue,
			"itemKey": "emissione_id",
			"filterKey": "id",
			"type": "array",
			"op": "in",
		};
        super.setFilterStructure("emissioniSelected", filterStructureLocal);

        let filterMapLocal = super.getFilterMap();
        console.log("filterMapLocal", filterMapLocal);
	}

    clearField(nameField: string, updateFilters: boolean = true){
        //console.log('clearField', nameField, updateFilters);
        switch(nameField){
            case "periodoInizioControl":{
                this.filterFormGroup.get('periodoInizioControl').setValue("");
                break;
            }
            case "periodoFineControl":{
                this.filterFormGroup.get('periodoFineControl').setValue("");
                break;
            }
            case "emissioniSelectedControl":{
                this.filterFormGroup.get('emissioniSelectedControl').setValue([]);
                break;
            }
        }
        if(updateFilters){
            this.updateFilters();
        }
    }

    updateFilters(){
        this.generateFilterMap();
        let filterMapLocal = super.getFilterMap();
        let eventObject = {
            type: 'updateFiltersMap',
            data: filterMapLocal,
        };
        console.log('UPDATE FILTERMAPLOCAL', eventObject);
        this.updateFilterEmitter.emit(eventObject);
    }

    resetFilters(){
        let filterMapLocal = super.getFilterMap();
        //console.log('RESET FILTER', filterMapLocal);
        super.setResetContext(true);
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                this.clearField(key, false);
            }
        }
        this.updateFilters();
        super.setResetContext(false);
        filterMapLocal = super.getFilterMap();
        //console.log('RESET FILTER', filterMapLocal);
        return filterMapLocal;
    }
}
